import f1 from "assets/img/posts/f1.jpg";
import f2 from "assets/img/posts/f2.jpg";
import { useDispatch } from "react-redux";
import { openLightBox } from "services/redux/lightbox/lightbox";
import { AppDispatch } from "services/redux/store";

const PostMedia2 = () => {
    const dispatch = useDispatch<AppDispatch>();
    return (
        <div className="post-image double-img">
            <div className="masonry-grid flex-j-center gap-10">
                {/* <!-- Left column --> */}
                <div
                    className="masonry-column-left cursor-pointer"
                    style={{ width: "45%" }}
                >
                    <img
                        src={f1}
                        // data-demo-src="assets/img/demo/unsplash/3.jpg"
                        alt=""
                        onClick={() => dispatch(openLightBox())}
                    />
                </div>
                {/* <!-- Right column --> */}
                <div
                    className="masonry-column-right cursor-pointer"
                    style={{ width: "45%" }}
                >
                    <img
                        src={f2}
                        data-demo-src="assets/img/demo/unsplash/5.jpg"
                        alt=""
                        onClick={() => dispatch(openLightBox())}
                    />
                </div>
            </div>
        </div>
    );
};

export default PostMedia2;
